import React, { useEffect, useState } from "react";
import "../transaction.scss";
import "../transactionMobile.scss";
import { useAppContext } from "../../../../../Components/AppProvider";
import Modal from "../Modal/Modal";
import PaymentProcedure from "../Modal/ModalContent/PaymentProcedure";
import PendingApprovalPartial from "./ToPayStatus/PendingApprovalPartial";
import { FaChevronUp, FaChevronDown, FaEllipsisV } from "react-icons/fa";

function DeclinedComponent() {
  const { declinedOrderList, setOrderListUpdate } = useAppContext();

  const [expanded, setExpanded] = useState({});
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [singleOrderToPay, setSingleOrderToPay] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);

  // ✅ Force fetch/update order list on load
  useEffect(() => {
    setOrderListUpdate(true);
  }, [setOrderListUpdate]);

  // ✅ Expand/collapse transaction
  const toggleExpand = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // ✅ Format date safely
  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  // ✅ Open payment modal
  const handlePaymentModal = () => {
    setModalOpen(true);
  };

  // ✅ Handle checkbox per order
  const handleSelectOrder = (id) => {
    setSelectedOrders((prev) =>
      prev.includes(id)
        ? prev.filter((orderId) => orderId !== id)
        : [...prev, id]
    );
  };

  // ✅ Filter transactions by search
  const filteredTransactions = declinedOrderList
    .map((tx) => {
      const keyword = searchTerm.toLowerCase();

      // Flatten transaction-level data
      const txString = Object.values(tx)
        .map((val) => (val ? String(val).toLowerCase() : ""))
        .join(" ");

      // Flatten order-items data
      const orderString = tx.OrderItems.map((order) =>
        Object.values(order)
          .map((val) => (val ? String(val).toLowerCase() : ""))
          .join(" ")
      ).join(" ");

      // If keyword matches transaction OR any order item → keep it
      if (txString.includes(keyword) || orderString.includes(keyword)) {
        return tx;
      }
      return null;
    })
    .filter(Boolean); // remove nulls

  return (
    <>
      <div className="oh-dp-container">
        {/* Header */}
        <div className="oh-dp-header">
          <div className="oh-dp-header-wrapper">DECLINED ORDER</div>
          <div className="oh-dp-button-wrapper">
            <input
              type="text"
              placeholder="Search transactions..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Transactions List */}
        <div className="transactions-list">
          {filteredTransactions.length > 0 ? (
            filteredTransactions.map((tx, index) => (
              <div key={tx.TransactionID} className="transaction-wrapper">
                {/* Transaction Header */}
                <div className="transaction-header">
                  {/**
                  <span
                    className="tx-icon"
                    onClick={() => toggleExpand(tx.TransactionID)}
                  >
                    {expanded[tx.TransactionID] ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </span> */}
                  <span className="tx-transnum">
                    <b>Transaction No.:</b> <br /> {tx.TransactionNumber}
                  </span>

                  <span className="tx-datepurchase">
                    <b>Transaction Date:</b> <br />{" "}
                    {formatToMMDDYYYY(tx.DatePurchase)}
                  </span>

                  <span className="tx-numberitems">
                    <b>No. of Items:</b> <br />
                    {tx.OrderItems.length}
                  </span>
                  <span className="tx-paymentmethod">
                    <b>Payment Method:</b> <br /> {tx.PaymentMethod}
                  </span>

                  <span className="tx-paymentamount">
                    <b>Amount Paid:</b>
                    <br /> PHP {tx.PaymentAmount}
                  </span>
                  <span className="tx-paymenttype">
                    <b>Payment Type:</b> <br /> {tx.PaymentType}
                  </span>
                </div>

                {/* Expandable Orders */}
                <div
                  className="transaction-orders expanded" /*${
                    expanded[tx.TransactionID] ? "expanded" : ""
                  }`}*/
                >
                  {tx.OrderItems.map((order, index) => (
                    <PendingApprovalPartial
                      key={order.COI_ID}
                      order={order}
                      index={index}
                      setSingleOrderToPay={setSingleOrderToPay}
                      handelPaymentModal={handlePaymentModal}
                      formatToMMDDYYYY={formatToMMDDYYYY}
                      selectedOrders={selectedOrders}
                      handleSelectOrder={handleSelectOrder}
                    />
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className="no-transactions-message">
              <p>No declined approvals found.</p>
            </div>
          )}
        </div>
      </div>

      {/* Payment Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <PaymentProcedure
          onClose={() => setModalOpen(false)}
          selectedOrders={
            singleOrderToPay
              ? [singleOrderToPay] // single order mode
              : declinedOrderList
                  .flatMap((tx) => tx.OrderItems)
                  .filter((order) => selectedOrders.includes(order.COI_ID))
          }
          setSelectedOrders={setSelectedOrders}
          setOrderListUpdate={setOrderListUpdate}
        />
      </Modal>
    </>
  );
}

export default DeclinedComponent;
